///
/// EarthBrowser
///
/// Created by Matt Giger on 4/10/2026
/// Copyright (c) 2026 Geodata Labs
///

export const anchoredReactPanelEventName = "earthbrowser:anchored-react-panel"
export const anchoredReactPanelDismissEventName = "earthbrowser:anchored-react-panel-dismiss"
export const anchoredReactPanelMeasuredEventName = "earthbrowser:anchored-react-panel-measured"

export interface AnchoredReactPanelState {
	visible: boolean
	x: number
	y: number
	width: number
	height: number
}

export function emitAnchoredReactPanelState(state: AnchoredReactPanelState): void {
	if (typeof window === "undefined") {
		return
	}

	window.dispatchEvent(new CustomEvent<AnchoredReactPanelState>(anchoredReactPanelEventName, {
		detail: state
	}))
}

export function requestDismissAnchoredPanel(): void {
	if (typeof window === "undefined") {
		return
	}

	window.dispatchEvent(new CustomEvent(anchoredReactPanelDismissEventName))
}

/**
 * React → engine: the rendered card's actual height. The size table only
 * holds nominal placement sizes; variable-height panels (placemark rollups,
 * expanded sections) report their real height so the engine's connector
 * line ends at the card edge instead of a phantom rectangle.
 */
export function emitAnchoredReactPanelMeasuredHeight(height: number): void {
	if (typeof window === "undefined") {
		return
	}

	window.dispatchEvent(new CustomEvent<number>(anchoredReactPanelMeasuredEventName, {
		detail: height
	}))
}
